import request from '@/utils/request'

/**
 * 行政区划列表
 * @param {*} data
 * @returns
 */
export const getXZQHList = (data) =>  request({
    method: 'get',
    url: `/organization/api/xzqh/manageTree`,
    data: data
})

/**
 * 新增行政区划
 * @param {*} data
 * @returns
 */
 export const addXZQH = (data) =>  request({
    method: 'post',
    url: `/organization/api/xzqh/add`,
    data: data
})

/**
 * 删除行政区划
 * @returns
 * @param id
 */
 export const deleteXZQH = (id) =>  request({
    method: 'delete',
    url: `/organization/api/xzqh/remove/${id}`
})

/**
 * 修改行政区划
 * @param {*} data
 * @returns
 */
 export const updateXZQH = (data) =>  request({
    method: 'put',
    url: `/organization/api/xzqh/edit`,
    data: data
})



